import Axios from "../config/config";

//Package APIS.
export const ADD_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('add-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('list-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULK_ASSIGN_MULTI_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('bulk-assign-multi-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const EDIT_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('edit-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const VIEW_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('view-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULK_ASSIGN_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('bulk-assign-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const ASSIGN_COURSE = async (body) => {
    try {
        const response = await Axios.post('assign-course/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LIST_COURSE_LEANERS = async (body) => {
    try {
        const response = await Axios.post('list-course-learners/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const LEANERS_COURSE_STATUS = async (body) => {
    try {
        const response = await Axios.post('learner-course-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};




export const ASSIGN_PACKAGE = async (body) => {
    try {
        const response = await Axios.post('assign-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const BULD_ASSIGN_PACKAGE_COURSE_TEMPLATE = async (body) => {
  try {
    const response = await Axios.post( 'bulk-assign-package-course-template/',body,
      {
        responseType: "blob",
      }
    );
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const LIST_PACKAGE_LEARNERS = async (body) => {
    try {
        const response = await Axios.post('list-package-learners/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const LIST_PACKAGE_COURSES = async (body) => {
    try {
        const response = await Axios.post('list-package-courses/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const ASSIGN_PACKAGE_COURSES = async (body) => {
    try {
        const response = await Axios.post('assign-course-to-package/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const LEARNER_PACKAGE_STATUS = async (body) => {
    try {
        const response = await Axios.post('learner-package-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};
